import { render, staticRenderFns } from "./MfaManagementComponent.vue?vue&type=template&id=950f5114&scoped=true"
import script from "./MfaManagementComponent.vue?vue&type=script&lang=js"
export * from "./MfaManagementComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950f5114",
  null
  
)

export default component.exports